<template>
  <div ref="dropArea" :class="['file-drop-box', dropClass]">
    <slot name="header" />
    <label :for="id" v-bind="$attrs">
      <div class="file-button">Browse Computer</div>
      <div class="file-name">{{ filename }}</div>
    </label>
    <input :id="id" type="file" />
    <slot name="footer" />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      files: [],
      fileObj: null,
      dropClass: ''
    }
  },
  mounted() {
    console.log(
      'this.$refs.dropArea',
      this.$refs.dropArea,
      this.$refs.dropArea.ondrag
    )
    const prevent = e => {
      e.preventDefault()
      e.stopPropagation()
    }

    // Disgusting hackery
    const dropArea = this.$refs.dropArea
    dropArea.ondrag = prevent
    dropArea.ondragstart = prevent
    dropArea.ondragend = prevent
    dropArea.ondragover = prevent
    dropArea.ondragenter = prevent
    dropArea.ondragleave = prevent
    dropArea.ondrop = prevent
    dropArea.ondragover = e => {
      prevent(e)
      this.dropClass = 'is-dragover'
    }
    dropArea.ondragenter = e => {
      prevent(e)
      this.dropClass = 'is-dragover'
    }
    dropArea.ondragleave = e => {
      prevent(e)
      this.dropClass = ''
    }
    dropArea.ondragend = e => {
      prevent(e)
      this.dropClass = ''
    }
    dropArea.ondrop = e => {
      prevent(e)
      this.dropClass = ''
      const droppedFiles = e.dataTransfer.files
      console.log('DROPED FILES', droppedFiles)
      this.fileObj = droppedFiles[0]
    }
  },
  beforeDestroy() {
    this.$refs.dropArea.off(
      'drag dragstart dragend dragover dragenter dragleave drop'
    )
  },
  methods: {},
  computed: {
    filename() {
      let filename = ''
      if (this.fileObj) {
        filename = this.fileObj.name
      }
      return filename
    }
  }
}
</script>

<style lang="scss" scoped>
input[type='file'] {
  display: none;
}

label {
  height: 65px;
  display: inline-flex;

  &:hover {
    cursor: pointer;

    .file-button {
      background-color: darken($white, 5%);
    }
  }
}

.file-name,
.file-button {
  border: solid 1px $gray;
  height: 65px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  position: relative;
  background: white;
  border-radius: 30px 0 0 30px;
  transition: background-color 222ms ease-in-out;
}

.file-name {
  border-radius: 0 30px 30px 0;
  border-left: none;
  min-width: 200px;
}

.file-drop-box {
  transition: background-color 222ms ease-in-out;
  position: relative;

  &:before {
    content: 'Drop Files For Upload';
    color: $white;
    transition: opacity 222ms ease-in-out;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    opacity: 0;
  }
}

.file-drop-box.is-dragover {
  background: darken($white, 15%);

  &:before {
    opacity: 1;
  }
}
</style>
